import InjectHighCPUUsage from './InjectHighCPUUsage';
import InjectMemoryLeak from './InjectMemoryLeak';
import InjectReRendersFromAnimations from './InjectReRendersFromAnimations';
import { jsx as _jsx } from "react/jsx-runtime";
function getLegacyRootLocalStorageOverride() {
  try {
    const value = localStorage.getItem('LEGACY_ROOT_OVERRIDE');
    const parsedValue = value !== null ? JSON.parse(value) : null;
    return typeof parsedValue === 'boolean' ? parsedValue : null;
  } catch (_unused) {
    return null;
  }
}
async function getTestDetailsFromAPI() {
  const response = await fetch('https://private.hubapiqa.com/rw-chaos/v1/app-failures/app', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
  if (!response.ok) {
    throw new Error(`Test details API failed: ${response.status} ${response.statusText}`);
  }
  const data = await response.json();
  if (!data) {
    throw new Error('Invalid test details API response format');
  }
  return data;
}
export async function processChaosTestDetails() {
  try {
    const response = await getTestDetailsFromAPI();
    const activeFailureTest = (response === null || response === void 0 ? void 0 : response.failureTypes.length) > 0 ? response.failureTypes[0] : null;
    let legacyRootOverride = getLegacyRootLocalStorageOverride();
    let chaosComponent = null;
    switch (activeFailureTest) {
      case 1:
        chaosComponent = /*#__PURE__*/_jsx(InjectMemoryLeak, {});
        break;
      case 2:
        chaosComponent = /*#__PURE__*/_jsx(InjectReRendersFromAnimations, {});
        break;
      case 3:
        chaosComponent = /*#__PURE__*/_jsx(InjectHighCPUUsage, {});
        break;
      case 4:
        legacyRootOverride = false;
        break;
      default:
        break;
    }
    return {
      legacyRootOverride,
      chaosComponent
    };
  } catch (error) {
    console.error('🎯 Chaos test API failed, falling back to defaults:', error);
    return {
      legacyRootOverride: getLegacyRootLocalStorageOverride(),
      chaosComponent: null
    };
  }
}